import React,{Component} from 'react';
import Header from './../Layout/Header1';
import Footer from './../Layout/Footer1';
import HomeOwlSlider from './../Element/HomeOwlSlider';
import HomeOwlSlider2 from './../Element/HomeOwlSlider2';
import ImgCarouselContent from './../Element/ImgCarouselContent';
import HomeTab from './../Element/HomeTab';
import Counter from './../Element/Counter';
import FormStyle from './../Element/FormStyle';
import ClientCarousel from '../Element/ClientCarousel';

//Images
import pic4 from './../../images/about/pic4.jpg';
import bgimg from './../../images/background/bg1.jpg';
import bg3 from './../../images/background/bg3.png';
import bg1 from './../../images/background/bg1.png';
import bg6 from './../../images/background/bg6.png';
// import bgimg2 from './../../images/background/bg-map.jpg';
import bgimg3 from './../../images/background/bg1.jpg';


class Homepage extends Component{
		
	componentDidMount() {
		
	}	
	
	render(){
		return(
			<div className="page-wraper">
				<Header />
				<div className="page-content bg-white">
					{/*  Slider Banner */}
					<div className="owl-slider-banner main-slider">
						<HomeOwlSlider />
						{/*  Service   */}
						<div className="service-box-slide">
							<div className="container">
								<div className="row">
									<div className="col-lg-12">
										<ImgCarouselContent />
									</div>
								</div>
							</div>
						</div>
						{/*  Service End  */}
					</div>
					{/*  Slider Banner */}
                    {/* <!-- Newsletter --> */}
                    <div className="section-full industry-service" style={{ backgroundImage: "url(" + bg3 + ")" }}>
                    <div className="content-inner newsletter-bx">
                            <div className="container">
                                <form className="row text-white dezPlaceAni align-items-center dzSubscribe m-lr0 "  action="#" method="post">
                                    <div className="col-xl-5 col-lg-6 col-md-12">
                                        <div className="title-bx">
                                            <h2 className="m-b10">Test Our Gateway</h2>
                                        </div>
                                    </div>
                                    <div className="col-xl-7 col-lg-6 col-md-12 contact-form-bx">
                                        <div className="form-group">
                                            <div className="input-group">
                                                {/* <label>Type your Number</label> */}
                                                <input name="text" required="required" type="number" className="form-control" placeholder="Type Your Number" />
                                                <button name="submit" value="Submit" type="submit" className="site-button radius-xl">Test Now</button>
                                            </div>
                                            <div className="dzSubscribeMsg"></div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        </div>
                        {/* <!-- Newsletter END --> */}
					<div className="content-block">
                        
                        {/* <!-- About Us --> */}
                        <div className="section-full industry-service" style={{ backgroundImage: "url(" + bg1 + ")" }}>
                            <div className="container col-10 blog-curve">
                                <div className="row ">
                                    <div className="col-lg-7 col-md-8">
                                        <div className="abuot-box row" >
                                            <div className="col-lg-4">
                                                <h2 className="box-title m-tb0">About Us<span className="bg-primary"></span></h2>
                                                <h4 className="text-gray-dark">We create unique experiences</h4>
                                            </div>
                                            <div className="col-lg-8">
                                                <p><h6>whiteBingTechnologies</h6>is a next-generation technology company that helps enterprises reimagine their businesses for the digital age using the power of technology to build better futures for our customers, colleagues, environment and communities.
                                                Every business worldwide is building event-driven, real-time applications - from financial services, eCommerce, transportation, and energy, to retail, healthcare, and Gaming companies.
                                                Our endeavor is to make it easy to develop innovative real-time applications and efficient to operate it in production.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-5 col-md-4 about-img" >
                                        <img src={pic4} data-tilt alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        {/* <!-- About Us End --> */}
						{/* <!-- Our Services --> */}
                        <div className="section-full content-inner-2">
                            <div className="container">
                                <div className="section-head text-black text-center">
                                    <h4 className="text-gray-dark m-b10">Our Services</h4>
                                    <h2 className="box-title m-tb0">Web Development & Cloud Services<span className="bg-primary"></span></h2>
                                    <p>We are dedicated to delivering the right people, solutions, and services to the clients that they require to meet their technology challenges and business goals.</p>
                                </div>
                            </div>
                            <div className="section-full industry-service" style={{ backgroundImage: "url(" + bg6 + ")" }}>
                            <div className="development-box">
                                <div className="container">
                                    <HomeOwlSlider2 />
                                </div>
                            </div>
                        </div>
                        </div>
                        {/* <!-- Our Services --> */}
						{/* <!-- Why Chose Us --> */}
                        <div className="section-full content-inner-1 overlay-primary choseus-tabs  bg-img-fix" style={{ backgroundImage: "url(" + bgimg + ")" }}>
                            <div className="container">
                                <div className="section-head text-white text-center">
                                    <h2 className="box-title m-tb0">Why Chose Us<span className="bg-primary"></span></h2>
                                    <p>We Make You Future Ready<br/>
                                    Aligned with Industry Standards & Trends, we deliver highly focused solutions for resolving your challenges and world-class capabilities to every client leveraging leading technologies & industry best practices.
                                    </p>
                                </div>
                            </div>
							<HomeTab />
							<div className="choses-info text-white">
                                <Counter />
                            </div>
						</div>	
						{/* <!-- Why Chose Us End --> */}
						
						{/* <!-- Get in touch --> */}
                        <div className="section-full overlay-primary-dark bg-img-fix" style={{ backgroundImage: "url(" + bgimg3 + ")" }}>
                            <FormStyle />
                        </div>
                        {/* <!-- Get in touch --> */}
						
					</div>
				</div>	
                
				<div className="section-full bg-primary-dark p-tb8">
                        <div className="container">
							<ClientCarousel /> 
                        </div>
                    </div>
                   
				<Footer />
				
			</div>		
		)
	}
}
export default Homepage;